export default __webpack_public_path__ + "static/media/Legal Policy Circle.2bb6b27c.svg";